import { Toaster } from '@/components/ui/sonner';

export default function Layout({ children }) {
  return (
    <>
      <div className="md:pl-64">
        <main className="pb-20 md:pb-6">
          {children}
        </main>
      </div>
      <Toaster position="top-center" />
    </>
  );
}
